import React, { HTMLProps, ReactElement } from "react";
import "./styles.scss";

interface ButtonProps extends HTMLProps<HTMLButtonElement> {
  text: string;
  variant?: "ghost";
  children?: ReactElement;
}

function Button({
  text,
  variant,
  className,
  type = "button",
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`button ${variant === "ghost" ? "ghost" : ""} ${
        className ? className : ""
      }`}
      {...rest}
    >
      {children}
      {text}
    </button>
  );
}

export { Button };
